import { render, staticRenderFns } from "./AvailabilityStatusBadge.vue?vue&type=template&id=9ff00abc&scoped=true&"
import script from "./AvailabilityStatusBadge.vue?vue&type=script&lang=js&"
export * from "./AvailabilityStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilityStatusBadge.vue?vue&type=style&index=0&id=9ff00abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff00abc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ff00abc')) {
      api.createRecord('9ff00abc', component.options)
    } else {
      api.reload('9ff00abc', component.options)
    }
    module.hot.accept("./AvailabilityStatusBadge.vue?vue&type=template&id=9ff00abc&scoped=true&", function () {
      api.rerender('9ff00abc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/AvailabilityStatusBadge.vue"
export default component.exports